// import Phaser from 'phaser'
import { MAP_CONFIG } from '../constants/game'
import { assetsImageLoader } from '../utils/funtions'
import { DEFAULT_BACKGROUND_CONTEXT } from './../constants/assets'

export default class MapComponent {
  /** @type {Phaser.GameObjects.Image} */
  map

  /** @type {{context: Phaser.Scene, bkgSrc:string}} config  */
  config = {}

  constructor(context, bkgSrc = DEFAULT_BACKGROUND_CONTEXT) {
    this.config.context = context
    this.config.bkgSrc = bkgSrc
  }

  // LOAD assets
  preload() {
    assetsImageLoader(
      { background: this.config.bkgSrc },
      `${this.config.context.scene.key}-`,
      this.config.context
    )
  }

  create() {

    this.map = this.config.context.add
      .image(0, 0, `${this.config.context.scene.key}-background`)
      .setOrigin(0);
     
 

    this.config.context.physics.world.setBounds(
      0,
      0, this.map.width, this.map.height
      + MAP_CONFIG.paddingBottom[this.config.context.data.get('mediaType')] - 1
    )
  }
}
